import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
export function ViewSectionQuestion() {
  const navigate = useNavigate();
  return <div className="space-y-4" data-id="element-2643">
      <div className="flex items-center justify-between" data-id="element-2644">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-2645">Section Question</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/questions')} data-id="element-2646">
          ← Back to Questions
        </Button>
      </div>

      <Card data-id="element-2647">
        <CardContent className="pt-6" data-id="element-2648">
          <table className="text-sm w-full" data-id="element-2649">
            <tbody data-id="element-2650">
              <tr className="border-b border-slate-100" data-id="element-2651">
                <td className="py-2 pr-6 font-medium text-slate-700 w-32 align-top" data-id="element-2652">
                  Id
                </td>
                <td className="py-2 text-slate-900" data-id="element-2653">101</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2654">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2655">
                  Course
                </td>
                <td className="py-2 text-slate-900" data-id="element-2656">Desert Ecology Basics</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2657">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2658">
                  Section
                </td>
                <td className="py-2 text-slate-900" data-id="element-2659">Section 1</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2660">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2661">
                  Question
                </td>
                <td className="py-2 text-slate-900 leading-relaxed" data-id="element-2662">
                  What is the primary water source for desert flora?
                </td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2663">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2664">Answer</td>
                <td className="py-2 text-slate-900 capitalize" data-id="element-2665">yes</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2666">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2667">
                  Created
                </td>
                <td className="py-2 text-slate-900" data-id="element-2668">2023-01-15</td>
              </tr>
              <tr data-id="element-2669">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2670">
                  Modified
                </td>
                <td className="py-2 text-slate-900" data-id="element-2671">2023-06-20</td>
              </tr>
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>;
}